import { render } from "./myProfile.vue?vue&type=template&id=635abe5b&scoped=true"
import script from "./myProfile.vue?vue&type=script&lang=js"
export * from "./myProfile.vue?vue&type=script&lang=js"

import "./myProfile.vue?vue&type=style&index=0&id=635abe5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635abe5b"]])

export default __exports__